import React from 'react';
import tpl from '../templates/personalInsurance.jsx';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';
import {withSSRData} from './../../../../../helpers/hoc/withSSRData';

class PersonalInsurance extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        const {detailedInsuranceInfoWidget, detailedIntermediaryInfoWidget} = props.ssrData || {};

        this.state = {
            ...this.state,
            tab: 'insurer-info',
            detailedInsuranceInfoWidget: detailedInsuranceInfoWidget || [],
            detailedInsuranceInfoWidget_loading: !detailedInsuranceInfoWidget,
            detailedIntermediaryInfoWidget: detailedIntermediaryInfoWidget || [],
            detailedIntermediaryInfoWidget_loading: !detailedIntermediaryInfoWidget
        };
    }

    componentDidMount() {
        if (this.state.detailedInsuranceInfoWidget_loading) {
            this.widgetsHelper.getWidgetsByPath.call(this, {
                path: '/services/personal-insurance-tab01',
                widgetKey: 'detailedInsuranceInfoWidget'
            });
        }
        if (this.state.detailedIntermediaryInfoWidget_loading) {
            this.widgetsHelper.getWidgetsByPath.call(this, {
                path: '/services/personal-insurance-tab02',
                widgetKey: 'detailedIntermediaryInfoWidget'
            });
        }
    }

    static displayName = 'PersonalInsurance';
}

export default withSSRData(PersonalInsurance);
